(() => {
  const element = document.getElementById('ls-language-reporting-config');
  if (!element || window.LukeSolveLanguageReporting) return;
  let config;
  try { config = JSON.parse(element.textContent); } catch { return; }
  const parameters = new URLSearchParams(location.search);
  if (config.enabled !== true || window.Shopify?.theme?.role !== 'main' ||
      ['preview_theme_id', 'ls_language_preview', 'ls_language_replay'].some(key => parameters.has(key))) return;
  const available = new Set(config.available);
  const pendingKey = 'lukesolve_language_reporting_pending_v1';
  const maximumAge = 7 * 24 * 60 * 60 * 1000;
  let visible = null;
  let exposure = null;
  let finished = false;
  const permitted = () => {
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; }
    catch { return false; }
  };
  const removePending = () => { try { localStorage.removeItem(pendingKey); } catch {} };
  const publish = (name, details) => {
    if (!permitted() || typeof window.Shopify?.analytics?.publish !== 'function') return false;
    try {
      const result = window.Shopify.analytics.publish(name, {
        ...details,
        release_version: config.version,
        current_language: config.language,
        page_path: location.pathname.slice(0, 100),
        occurred_at: new Date().toISOString()
      });
      if (result === false) return false;
      if (result?.catch) result.catch(() => {});
      return true;
    } catch { return false; }
  };
  const recordVisible = () => {
    if (!visible || exposure || finished || !permitted() ||
        !document.getElementById('ls-language-prompt')?.open || document.visibilityState !== 'visible') return;
    if (!window.crypto?.randomUUID) return;
    const details = {
      prompt_id: window.crypto.randomUUID(),
      suggested_country: visible.country,
      suggested_languages: visible.languages.join(','),
      shown_at: Date.now()
    };
    if (publish('ls_language_prompt_view', details)) exposure = details;
  };
  const decision = (choice, language = config.language) => {
    if (finished || !visible) return;
    recordVisible();
    finished = true;
    if (!exposure || !permitted()) return;
    const details = { ...exposure, choice_type: choice, chosen_language: language };
    if (!publish('ls_language_prompt_choice', details)) return;
    if ((choice === 'suggested' || choice === 'other') && available.has(language)) {
      try { localStorage.setItem(pendingKey, JSON.stringify({ ...details, chosen_at: Date.now() })); } catch {}
    }
  };
  const confirmApplied = () => {
    if (!permitted()) return;
    let pending;
    try { pending = JSON.parse(localStorage.getItem(pendingKey) || 'null'); } catch { removePending(); return; }
    if (!pending) return;
    const age = Date.now() - Number(pending.chosen_at);
    if (!pending.prompt_id || age < 0 || age > maximumAge) { removePending(); return; }
    if (pending.chosen_language !== config.language) return;
    if (publish('ls_language_prompt_applied', {
      prompt_id: pending.prompt_id,
      suggested_country: pending.suggested_country,
      suggested_languages: pending.suggested_languages,
      shown_at: pending.shown_at,
      choice_type: pending.choice_type,
      chosen_language: pending.chosen_language
    })) removePending();
  };
  window.LukeSolveLanguageReporting = Object.freeze({
    shown(country, languages) {
      if (visible || !/^[A-Z]{2}$/.test(country)) return;
      visible = { country, languages: languages.filter(code => available.has(code)) };
      recordVisible();
    },
    choose(language, primary) {
      if (available.has(language)) decision(primary ? 'suggested' : 'other', language);
    },
    keepEnglish() { decision('keep_english', 'en'); },
    dismiss(reason) { decision(reason === 'escape' ? 'dismiss_escape' : 'dismiss_close'); },
    hidden() { visible = null; finished = true; }
  });
  const privacyReady = () => {
    if (!permitted()) {
      removePending();
      exposure = null;
      return;
    }
    confirmApplied();
    recordVisible();
  };
  document.addEventListener('visitorConsentCollected', privacyReady);
  document.addEventListener('visibilitychange', recordVisible);
  if (window.Shopify?.customerPrivacy) privacyReady();
  else if (typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
      if (!error) privacyReady();
    });
  }
})();
